import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30;

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import { ORDER_TYPE } from ".";
import maxBy from "lodash/maxBy";
import { action, computed, makeObservable, observable, runInAction } from "mobx";
import BrandRules from "../../utils/BrandRules";
import { decodeIsAlcohol, decodeIsAdvanceOrderingProduct, findMenuItemAvailibity } from "../../utils/common";
export var IMenuItemPropertyVariant;

(function (IMenuItemPropertyVariant) {
  IMenuItemPropertyVariant["ACCORDION_WITH_LIST"] = "ACCORDION_WITH_LIST";
  IMenuItemPropertyVariant["ACCORDION_WITH_CAROUSEL"] = "ACCORDION_WITH_CAROUSEL";
  IMenuItemPropertyVariant["TEMPERATURE_CONTROL"] = "TEMPERATURE_CONTROL";
  IMenuItemPropertyVariant["CAROUSEL"] = "CAROUSEL";
  IMenuItemPropertyVariant["CAROUSEL_WITH_HEADER"] = "CAROUSEL_WITH_HEADER";
  IMenuItemPropertyVariant["SLIDER"] = "SLIDER";
  IMenuItemPropertyVariant["LIST_ITEM_WITH_HEADER"] = "LIST_ITEM_WITH_HEADER";
  IMenuItemPropertyVariant["LIST_ITEM_COLLAPSED_BY_REQUIRED"] = "LIST_ITEM_COLLAPSED_BY_REQUIRED";
})(IMenuItemPropertyVariant || (IMenuItemPropertyVariant = {}));

export var IMenuItemOptionVariant;

(function (IMenuItemOptionVariant) {
  IMenuItemOptionVariant["BUTTON_ADD_ITEM"] = "BUTTON_ADD_ITEM";
  IMenuItemOptionVariant["BUTTON_REMOVE_ITEM"] = "BUTTON_REMOVE_ITEM";
  IMenuItemOptionVariant["LIST_ITEM"] = "LIST_ITEM";
  IMenuItemOptionVariant["LIST_ITEM_WITH_ONE_SLIDER"] = "LIST_ITEM_WITH_ONE_SLIDER";
  IMenuItemOptionVariant["LIST_ITEM_WITH_MULTIPLE_SLIDERS"] = "LIST_ITEM_WITH_MULTIPLE_SLIDERS";
  IMenuItemOptionVariant["LIST_ITEM_WITH_ONE_CAROUSEL"] = "LIST_ITEM_WITH_ONE_CAROUSEL";
  IMenuItemOptionVariant["LIST_ITEM_WITH_MULTIPLE_CAROUSELS"] = "LIST_ITEM_WITH_MULTIPLE_CAROUSELS";
  IMenuItemOptionVariant["CAROUSEL_ITEM"] = "CAROUSEL_ITEM";
  IMenuItemOptionVariant["CAROUSEL_ITEM_WITH_SLIDER"] = "CAROUSEL_ITEM_WITH_SLIDER";
  IMenuItemOptionVariant["SLIDER_ITEM"] = "SLIDER_ITEM";
})(IMenuItemOptionVariant || (IMenuItemOptionVariant = {}));

export var ItemCourse;

(function (ItemCourse) {
  ItemCourse["FIRST_COURSE"] = "FIRST_COURSE";
  ItemCourse["SECOND_COURSE"] = "SECOND_COURSE";
})(ItemCourse || (ItemCourse = {}));

var MenuDetailModel = (_dec = observable.ref, (_class = /*#__PURE__*/function () {
  // @observable private _isValid = true;
  // @observable private _lastValidatedAt = Date.now();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  function MenuDetailModel(platformUtil, _editMode) {
    var _this = this;

    _classCallCheck(this, MenuDetailModel);

    _defineProperty(this, "_editMode", false);

    _initializerDefineProperty(this, "_quantity", _descriptor, this);

    _initializerDefineProperty(this, "_label", _descriptor2, this);

    _initializerDefineProperty(this, "_specialInstructions", _descriptor3, this);

    _initializerDefineProperty(this, "_warnings", _descriptor4, this);

    _initializerDefineProperty(this, "_menuItemDetail", _descriptor5, this);

    _initializerDefineProperty(this, "_showNutritionalInfo", _descriptor6, this);

    _initializerDefineProperty(this, "_category", _descriptor7, this);

    _initializerDefineProperty(this, "_menulists", _descriptor8, this);

    _initializerDefineProperty(this, "_recommendationsList", _descriptor9, this);

    _initializerDefineProperty(this, "_showValidations", _descriptor10, this);

    _initializerDefineProperty(this, "_upperSectionHeight", _descriptor11, this);

    _initializerDefineProperty(this, "_resturantId", _descriptor12, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor13, this);

    _initializerDefineProperty(this, "_editMenuId", _descriptor14, this);

    _initializerDefineProperty(this, "_orderTypeValue", _descriptor15, this);

    _initializerDefineProperty(this, "_unavailableItems", _descriptor16, this);

    _initializerDefineProperty(this, "_sessionDetails", _descriptor17, this);

    _initializerDefineProperty(this, "_selectedItemSlug", _descriptor18, this);

    _initializerDefineProperty(this, "_currentPickupTime", _descriptor19, this);

    _initializerDefineProperty(this, "_configPropertyRefs", _descriptor20, this);

    _initializerDefineProperty(this, "_menulistMap", _descriptor21, this);

    _initializerDefineProperty(this, "_isFromRecommended", _descriptor22, this);

    _initializerDefineProperty(this, "_isScrollEnabledFlag", _descriptor23, this);

    _initializerDefineProperty(this, "_isMenuItemLoading", _descriptor24, this);

    _initializerDefineProperty(this, "_isItemCourseSwitched", _descriptor25, this);

    _initializerDefineProperty(this, "_enableItemLevelInstruction", _descriptor26, this);

    _defineProperty(this, "setConfigPropertyRefs", function (code, ref) {
      runInAction(function () {
        _this._configPropertyRefs[code] = ref;
      });
    });

    _defineProperty(this, "clearConfigPropertyRefs", function () {
      runInAction(function () {
        _this._configPropertyRefs = {};
      });
    });

    _initializerDefineProperty(this, "selectOptionBySelectedId", _descriptor27, this);

    _initializerDefineProperty(this, "selectSKU", _descriptor28, this);

    _initializerDefineProperty(this, "setShowNutritionalInfo", _descriptor29, this);

    _initializerDefineProperty(this, "setIsFromRecommended", _descriptor30, this);

    makeObservable(this);
    this._editMode = _editMode;
  }

  _createClass(MenuDetailModel, [{
    key: "setPickupTimeData",
    value: function setPickupTimeData(data) {
      var _this2 = this;

      runInAction(function () {
        _this2._currentPickupTime = data;
      });
    }
  }, {
    key: "setEditMenuId",
    value: function setEditMenuId(id) {
      var _this3 = this;

      runInAction(function () {
        _this3._editMenuId = id;
      });
    }
  }, {
    key: "setSessionDetails",
    value: function setSessionDetails(_sessionDetails) {
      var _this4 = this;

      runInAction(function () {
        _this4._sessionDetails = _sessionDetails;
      });
    }
  }, {
    key: "setAppAttributesData",
    value: function setAppAttributesData(_appAttributes) {
      var _this5 = this;

      runInAction(function () {
        _this5._appAttributes = _appAttributes;
      });
    }
  }, {
    key: "getImageUrl",
    value: function getImageUrl(url) {
      if (url === null || !url) {
        if (this._appAttributes.concept.conceptCode === "LH") {
          return this._appAttributes.configs.mediaRoot_menulistingimage_url;
        } else {
          return this._appAttributes.configs.mediaRoot_stoneimage_url;
        }
      }

      return url;
    }
  }, {
    key: "getCalorieCount",
    value: function getCalorieCount(nutritionFacts) {
      var _this6 = this;

      if (!this.selectedSkuId && (nutritionFacts === null || nutritionFacts === void 0 ? void 0 : nutritionFacts.length) > 0) {
        var _nutritionFacts$;

        return (_nutritionFacts$ = nutritionFacts[0]) === null || _nutritionFacts$ === void 0 ? void 0 : _nutritionFacts$.nutritionalFDAMessage;
      }

      return nutritionFacts === null || nutritionFacts === void 0 ? void 0 : nutritionFacts.filter(function (nutritionFact) {
        return _this6.selectedSkuId === nutritionFact.sku;
      }).map(function (nutritionFact) {
        return nutritionFact.nutritionalFDAMessage;
      });
    }
  }, {
    key: "checkMenuItemAvailibility",
    value: function checkMenuItemAvailibility(id, dayPartInfo, advanceOrdering) {
      return this.unavailableProducts["".concat(id)] ? {
        isUnavailable: true,
        unAvailableMessage: ""
      } : findMenuItemAvailibity({
        dayPartInfo: dayPartInfo,
        advanceOrdering: advanceOrdering,
        currentPickupTime: this._currentPickupTime
      });
    }
  }, {
    key: "_decodeIsAdvanceOrderingProduct",
    value: function _decodeIsAdvanceOrderingProduct(isUnavailable, unAvailableMessage) {
      var _this$_appAttributes, _this$_appAttributes$;

      return decodeIsAdvanceOrderingProduct(isUnavailable, unAvailableMessage, (_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : (_this$_appAttributes$ = _this$_appAttributes.configs) === null || _this$_appAttributes$ === void 0 ? void 0 : _this$_appAttributes$.isAdvanceOrderingAllowed);
    }
  }, {
    key: "checkSkuAvailibility",
    value: function checkSkuAvailibility(id) {
      return !!this.unavailableModifiers["".concat(id)];
    }
  }, {
    key: "setUnavailableItemsData",
    value: function setUnavailableItemsData(_unavailableItems) {
      var _this7 = this;

      runInAction(function () {
        _this7._unavailableItems = _unavailableItems;
      });
    }
  }, {
    key: "setOrderTypeValue",
    value: function setOrderTypeValue(order) {
      this._orderTypeValue = order === null || order === void 0 ? void 0 : order.orderType;
    }
  }, {
    key: "decodeIndicators",
    value: function decodeIndicators(indicators) {
      var _this$_appAttributes2;

      var indicatorIconBaseUrl = (_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : _this$_appAttributes2.configs.mediaRoot_marketing_indicator_https;
      var topIndicators;
      var bottomIndicators = [];

      if ((indicators === null || indicators === void 0 ? void 0 : indicators.length) === 0) {
        return {
          topIndicators: topIndicators,
          bottomIndicators: bottomIndicators
        };
      }

      try {
        var _this$_appAttributes3, _this$_appAttributes4, _indicators$map, _indicators$map$filte, _indicators$map2, _indicators$map2$filt;

        var excludedIndecators = JSON.parse((_this$_appAttributes3 = this._appAttributes) === null || _this$_appAttributes3 === void 0 ? void 0 : (_this$_appAttributes4 = _this$_appAttributes3.configs) === null || _this$_appAttributes4 === void 0 ? void 0 : _this$_appAttributes4.topIndicators);
        bottomIndicators = indicators === null || indicators === void 0 ? void 0 : (_indicators$map = indicators.map(function (ind) {
          var _excludedIndecators$i;

          var isTopIndicator = excludedIndecators === null || excludedIndecators === void 0 ? void 0 : (_excludedIndecators$i = excludedIndecators.indicatorList) === null || _excludedIndecators$i === void 0 ? void 0 : _excludedIndecators$i.find(function (item) {
            return item.indicatorCode === ind.code;
          });

          if (isTopIndicator) {
            return undefined;
          }

          if (ind.code.includes("Sodium Philly")) {
            return undefined;
          }

          var indicator = ind;

          if (!indicator) {
            return undefined;
          }

          return {
            iconUrl: "".concat(indicatorIconBaseUrl, "/").concat(indicator.imageUrl),
            tooltipText: indicator.legendText,
            indicatorCode: indicator.code
          };
        })) === null || _indicators$map === void 0 ? void 0 : (_indicators$map$filte = _indicators$map.filter(function (i) {
          return i !== undefined;
        })) === null || _indicators$map$filte === void 0 ? void 0 : _indicators$map$filte.slice(0, 3);
        topIndicators = indicators === null || indicators === void 0 ? void 0 : (_indicators$map2 = indicators.map(function (ind) {
          var _excludedIndecators$i2;

          var isTopIndicator = excludedIndecators === null || excludedIndecators === void 0 ? void 0 : (_excludedIndecators$i2 = excludedIndecators.indicatorList) === null || _excludedIndecators$i2 === void 0 ? void 0 : _excludedIndecators$i2.find(function (item) {
            return item.indicatorCode === ind.code;
          });

          if (!isTopIndicator) {
            return undefined;
          }

          var indicator = ind;

          if (!indicator) {
            return undefined;
          }

          var indicatorText = excludedIndecators === null || excludedIndecators === void 0 ? void 0 : excludedIndecators.indicatorList.find(function (item) {
            return item.indicatorCode === indicator.code;
          }).indicatorText;
          return {
            iconUrl: "".concat(indicatorIconBaseUrl, "/").concat(indicator.imageUrl),
            tooltipText: indicatorText.toUpperCase(),
            indicatorCode: indicator.code
          };
        })) === null || _indicators$map2 === void 0 ? void 0 : (_indicators$map2$filt = _indicators$map2.filter(function (i) {
          return i !== undefined;
        })) === null || _indicators$map2$filt === void 0 ? void 0 : _indicators$map2$filt.slice(0, 3)[0];
      } catch (e) {
        console.log("error", e);
      }

      return {
        topIndicators: topIndicators,
        bottomIndicators: bottomIndicators
      };
    }
  }, {
    key: "decodeIsNew",
    value: function decodeIsNew(indicators) {
      return indicators === null || indicators === void 0 ? void 0 : indicators.some(function (ind) {
        return (ind === null || ind === void 0 ? void 0 : ind.code) === "NI";
      });
    }
  }, {
    key: "decodeSodiumIndicator",
    value: function decodeSodiumIndicator(indicators) {
      var _this$_appAttributes5, _this$_appAttributes6;

      var indicatorsMap = (_this$_appAttributes5 = this._appAttributes) === null || _this$_appAttributes5 === void 0 ? void 0 : _this$_appAttributes5.indicatorsMap;
      var indicatorIconBaseUrl = (_this$_appAttributes6 = this._appAttributes) === null || _this$_appAttributes6 === void 0 ? void 0 : _this$_appAttributes6.configs.mediaRoot_marketing_indicator_https;

      if (!indicatorsMap) {
        return null;
      }

      var transformedIndicator = indicators === null || indicators === void 0 ? void 0 : indicators.find(function (indicator) {
        return indicator.code.includes("Sodium Philly");
      });
      var indicator = indicatorsMap[transformedIndicator === null || transformedIndicator === void 0 ? void 0 : transformedIndicator.code];

      if (indicator) {
        return {
          iconUrl: "".concat(indicatorIconBaseUrl, "/").concat(indicator.imageUrl),
          tooltipText: indicator.longDescription,
          indicatorCode: indicator.indicatorCode
        };
      } else {
        return null;
      }
    }
  }, {
    key: "decodeIfDisplayPrice",
    value: function decodeIfDisplayPrice(price) {
      return this.isPriceHidden || (price === null || price === void 0 ? void 0 : price.toFixed(2)) === "0.00";
    }
  }, {
    key: "_decodeIsAlcohol",
    value: function _decodeIsAlcohol(isAlcohol, alcoholSubClassification) {
      var _this$_sessionDetails;

      return decodeIsAlcohol(isAlcohol, (_this$_sessionDetails = this._sessionDetails) === null || _this$_sessionDetails === void 0 ? void 0 : _this$_sessionDetails.restaurantDetails, alcoholSubClassification, this.orderType);
    }
  }, {
    key: "decodeRecommendations",
    value: function decodeRecommendations(recomendation, menulist) {
      return menulist.find(function (_menu) {
        return _menu.id === recomendation.id;
      });
    }
  }, {
    key: "setReturantId",
    value: function setReturantId(_id) {
      var _this8 = this;

      runInAction(function () {
        _this8._resturantId = _id;
      });
    }
  }, {
    key: "setCategoryData",
    value: function setCategoryData(_category) {
      var _this9 = this;

      runInAction(function () {
        _this9._category = _category;
      });
    }
  }, {
    key: "setMenuListData",
    value: function setMenuListData(_list) {
      var _this10 = this;

      var menuListMap = {};

      if (_list && Array.isArray(_list)) {
        _list.forEach(function (_i) {
          Object.assign(menuListMap, _defineProperty({}, _i.id, _i));
        });
      }

      runInAction(function () {
        _this10._menulists = _list;
        _this10._menulistMap = menuListMap;
      });
    }
  }, {
    key: "_checkSkuIsBeverageItem",
    value: function _checkSkuIsBeverageItem(isBeverageItem, isAlcohol) {
      // if sku is not Beverage Item just return false
      if (!isBeverageItem) {
        return false;
      } // if Order Ahead


      if (this.orderType === ORDER_TYPE.ORDER_AHEAD) {
        var _this$_sessionDetails2, _this$_sessionDetails3;

        if (!!((_this$_sessionDetails2 = this._sessionDetails) !== null && _this$_sessionDetails2 !== void 0 && (_this$_sessionDetails3 = _this$_sessionDetails2.restaurantDetails) !== null && _this$_sessionDetails3 !== void 0 && _this$_sessionDetails3.enableNABOrderAhead) && !isAlcohol) {
          // enabled Add CTA
          return false;
        } // Show Order With Server


        return true;
      } else {
        var _this$menuItem; // disable skus if Item is DINE IN ONLY


        return (_this$menuItem = this.menuItem) === null || _this$menuItem === void 0 ? void 0 : _this$menuItem.isDineInOnly;
      }
    }
  }, {
    key: "setShowValidations",
    value: function setShowValidations(val) {
      this._showValidations = val;
    }
  }, {
    key: "setUpperSectionHeight",
    value: function setUpperSectionHeight(val) {
      this._upperSectionHeight = val;
    }
  }, {
    key: "findFirstInvalidProperty",
    value: function findFirstInvalidProperty(properties) {
      if (!properties) return undefined;

      var _iterator = _createForOfIteratorHelper(properties),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var p = _step.value;

          if (p.isInvalid) {
            return p.id;
          }

          var invalidId = this.findFirstInvalidProperty(p.options.flatMap(function (o) {
            return o.properties;
          }));

          if (invalidId) {
            return invalidId;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return undefined;
    }
  }, {
    key: "firstInvalidProperty",
    value: function firstInvalidProperty() {
      return this.findFirstInvalidProperty(this.menuItemSku.properties);
    } // @action validate() {
    //   this._lastValidatedAt = Date.now();
    //   const firstInvalidProperty = this.findFirstInvalidProperty(
    //     this.menuItemSku.properties,
    //   );
    //   if (firstInvalidProperty) {
    //     runInAction(() => {
    //       this._isValid = false;
    //       this._showValidations = true;
    //     });
    //   } else {
    //     runInAction(() => {
    //       this._isValid = true;
    //       this._showValidations = false;
    //     });
    //   }
    // }
    // @computed get lastValidatedAt() {
    //   return this._lastValidatedAt;
    // }

  }, {
    key: "decodeErrorMessage",
    value: function decodeErrorMessage(property) {
      return "Oops! You forgot to add ".concat(property === null || property === void 0 ? void 0 : property.displayName);
    }
  }, {
    key: "getSelectedOptionsCount",
    value: function getSelectedOptionsCount(mappedOptions) {
      var count = 0;
      var suffix = "";
      mappedOptions.forEach(function (option) {
        if (option.optionType) {
          if (option.optionType === "No") {
            suffix = "Removed";
          } else if (option.optionType === "All" || option.optionType === "Confirm") {
            suffix = "Added";
          }

          if (option.isSelected) {
            count += 1;
          }
        }
      });
      return suffix && count > 0 ? " ".concat(count, " ").concat(suffix) : "";
    }
  }, {
    key: "_getProperties",
    value: function _getProperties(options) {
      var _this11 = this,
          _this$menuItemSkus,
          _this$_appAttributes7;

      var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      if (!options || !options.length) return [];
      var unsortedProperties = options.map(function (propOpt, i) {
        var _this11$_appAttribute, _this11$_appAttribute2, _this11$_appAttribute3;

        var optionId = propOpt.optionId,
            optionName = propOpt.optionName,
            displayName = propOpt.displayName,
            isMandatory = propOpt.isMandatory,
            isCollapsible = propOpt.isCollapsible,
            isMultiSelect = propOpt.isMultiSelect,
            options = propOpt.options,
            description = propOpt.description,
            renderingOption = propOpt.renderingOption,
            isAlcohol = propOpt.isAlcohol,
            isInValid = propOpt.isInValid,
            parentOptionVariant = propOpt.parentOptionVariant,
            heading = propOpt.heading,
            isDirty = propOpt.isDirty,
            depth = propOpt.depth,
            floor = propOpt.floor,
            selected = propOpt.selected,
            adminDisplayName = propOpt.adminDisplayName; // property -> options[], propertyVariant

        var showImage = new BrandRules(_this11 === null || _this11 === void 0 ? void 0 : (_this11$_appAttribute = _this11._appAttributes) === null || _this11$_appAttribute === void 0 ? void 0 : _this11$_appAttribute.currentConceptCode).showMenuImages(propOpt);

        var _this11$_getOptions = _this11._getOptions({
          options: options,
          level: level,
          renderingOption: renderingOption,
          _optionName: optionName,
          showImage: showImage,
          isMandatory: isMandatory
        }),
            mappedOptions = _this11$_getOptions.mappedOptions,
            variant = _this11$_getOptions.propertyVariant;

        var noOfChildLevels = mappedOptions.length ? maxBy(mappedOptions, "noOfChildLevels").noOfChildLevels : 0;
        var unavailableItems = mappedOptions.filter(function (item) {
          return item.isUnavailable;
        });

        if (unavailableItems.length) {
          var availableItems = mappedOptions.filter(function (item) {
            return !item.isUnavailable;
          });
          mappedOptions = [].concat(_toConsumableArray(availableItems), _toConsumableArray(unavailableItems));
        }

        var newSelectedDescription = description;
        var selectedSubOptions = propOpt.selectedConfigOptions;
        newSelectedDescription = new BrandRules(_this11 === null || _this11 === void 0 ? void 0 : (_this11$_appAttribute2 = _this11._appAttributes) === null || _this11$_appAttribute2 === void 0 ? void 0 : _this11$_appAttribute2.currentConceptCode).getSelectedOptionDescription(selectedSubOptions);
        var showDescriptionBox = new BrandRules(_this11 === null || _this11 === void 0 ? void 0 : (_this11$_appAttribute3 = _this11._appAttributes) === null || _this11$_appAttribute3 === void 0 ? void 0 : _this11$_appAttribute3.currentConceptCode).isTemperatureDescriptionVisible();

        var _isDefaultExpanded = function _isDefaultExpanded() {
          if (isMandatory) return true;else if (!isMandatory && !isCollapsible) return true;else if (!isMandatory && isCollapsible) return false;else return false;
        };

        return {
          id: optionId,
          code: optionId,
          name: heading,
          description: description,
          variant: variant,
          required: isMandatory,
          showRequiredLabel: _this11.showRequiredLabel,
          multiSelect: isMultiSelect,
          isExpanded: isMandatory,
          isDefaultExpanded: _isDefaultExpanded(),
          isMandatory: isMandatory,
          selectedDescription: newSelectedDescription,
          stepNumber: i + 1,
          noOfChildLevels: noOfChildLevels,
          options: mappedOptions,
          errorMessage: _this11.decodeErrorMessage(propOpt),
          // showErrorMessage: isInValid && this.showValidations,
          isInvalid: isInValid,
          // lastValidatedAt: this.lastValidatedAt,
          level: 1,
          isAlcohol: isAlcohol,
          selectedCount: _this11.getSelectedOptionsCount(mappedOptions),
          showDescriptionBox: showDescriptionBox,
          title: _this11.getTemperatureSelectionTitle(heading, description),
          placeholder: _this11.getTemperatureSelectionPlaceholder(adminDisplayName),
          parentOptionVariant: parentOptionVariant,
          isDirty: isDirty,
          depth: depth,
          floor: floor,
          selected: selected
        };
      });
      var filteredSortedProperties = unsortedProperties.filter(function (p) {
        return p.options && p.options.length > 0;
      });
      if (level !== 1) return unsortedProperties;
      var stepNumberOffset = 0;
      var noOfVariants = (_this$menuItemSkus = this.menuItemSkus) === null || _this$menuItemSkus === void 0 ? void 0 : _this$menuItemSkus.length;

      if (level === 1 && noOfVariants > 1) {
        stepNumberOffset = 1;
      }

      var filteredOutRedundantProperties = new BrandRules(this === null || this === void 0 ? void 0 : (_this$_appAttributes7 = this._appAttributes) === null || _this$_appAttributes7 === void 0 ? void 0 : _this$_appAttributes7.currentConceptCode).getFilteredOutRedundantOptions(filteredSortedProperties);
      filteredOutRedundantProperties === null || filteredOutRedundantProperties === void 0 ? void 0 : filteredOutRedundantProperties.forEach(function (p, index) {
        p.stepNumber = index + stepNumberOffset + 1;
      });
      return filteredOutRedundantProperties;
    }
  }, {
    key: "_decodeIsBeverageItem",
    value: function _decodeIsBeverageItem(isAlcohol, isBeverageItem, isMandatory) {
      if (this.orderType === ORDER_TYPE.ORDER_AHEAD && !isMandatory && //Allow mandatory options to select
      isBeverageItem) {
        var _this$_sessionDetails4, _this$_sessionDetails5;

        if (!!((_this$_sessionDetails4 = this._sessionDetails) !== null && _this$_sessionDetails4 !== void 0 && (_this$_sessionDetails5 = _this$_sessionDetails4.restaurantDetails) !== null && _this$_sessionDetails5 !== void 0 && _this$_sessionDetails5.enableNABOrderAhead) && !isAlcohol) {
          return false;
        }

        return true;
      }

      return false;
    }
  }, {
    key: "_getOptions",
    value: function _getOptions(_ref) {
      var _this12 = this;

      var options = _ref.options,
          level = _ref.level,
          showImage = _ref.showImage,
          isMandatory = _ref.isMandatory;
      if (!options || !options.length) return {
        mappedOptions: [],
        propertyVariant: null
      };
      var propVariant;
      var mappedOptions = options.map(function (opt, idx) {
        var _this12$_decodeIsAlco;

        var selectedId = opt.selectedId,
            optionId = opt.optionId,
            selected = opt.selected,
            thumbnailImage = opt.thumbnailImage,
            description = opt.description,
            optionType = opt.optionType,
            price = opt.price,
            name = opt.name,
            selectionDisplayName = opt.selectionDisplayName,
            properties = opt.options,
            skuDisplayName = opt.skuDisplayName,
            isBeverageItem = opt.isBeverageItem,
            _isAlcohol = opt.isAlcohol,
            alcoholSubClassification = opt.alcoholSubClassification,
            displayPrice = opt.displayPrice;
        var isAlcohol = (_this12$_decodeIsAlco = _this12._decodeIsAlcohol(_isAlcohol, alcoholSubClassification)) === null || _this12$_decodeIsAlco === void 0 ? void 0 : _this12$_decodeIsAlco.isAlcohol;

        var mappedProperties = _this12._getProperties(properties, level + 1);

        var noOfChildLevels = mappedProperties.length ? maxBy(mappedProperties, "noOfChildLevels").noOfChildLevels : 0; // As discussed selected item description is removed from options.
        // let newSelectedDescription = description;
        // const selectedSubOptions = opt.selectedConfigOptions;
        // const newSelectedDescription = new BrandRules(
        //   this?._appAttributes?.currentConceptCode,
        // ).getSelectedOptionDescription(selectedSubOptions);
        // Calculate this only once

        if (idx === 0) {
          propVariant = opt.parent.variant;
        }

        return {
          id: selectedId,
          code: selectedId,
          name: description || name,
          value: selectedId,
          imageUrl: thumbnailImage,
          isSelected: selected,
          selectedDescription: "",
          skuId: optionId,
          selectedId: selectedId,
          optionType: optionType,
          price: price,
          displayPrice: displayPrice,
          isDisabled: _this12._isOptionDisabled(selectedId, selected),
          variant: opt.variant,
          isUnavailable: _this12.checkSkuAvailibility(optionId),
          noOfChildLevels: noOfChildLevels + 1,
          properties: mappedProperties,
          description: description,
          longDescription: description,
          showImage: showImage,
          selectionDisplayName: selectionDisplayName,
          skuDisplayName: skuDisplayName,
          isBeverageItem: _this12._decodeIsBeverageItem(isAlcohol, isBeverageItem, isMandatory),
          isAlcohol: isAlcohol
        };
      });
      return {
        mappedOptions: mappedOptions,
        propertyVariant: propVariant
      };
    }
  }, {
    key: "setMenuItemDetailData",
    value: function setMenuItemDetailData(item) {
      this._menuItemDetail = item;
    }
  }, {
    key: "setRecommendationData",
    value: function setRecommendationData(_recomentations) {
      this._recommendationsList = _recomentations;
    }
  }, {
    key: "makeSelectionConfirmTypeOption",
    // making selection of Confirm type opions
    value: function makeSelectionConfirmTypeOption(configOption) {
      var _this13 = this; // if ConfigOption has ConfigProperty


      if (configOption.options) {
        configOption.options.forEach(function (_configProperties) {
          // if  ConfigProperty has ConfigOption
          if (_configProperties.options) {
            _configProperties.options.forEach(function (_configOption) {
              if (_configOption.optionType === "Confirm") {
                var isUnavailable = _this13.checkSkuAvailibility(_configOption.optionId);

                if (!isUnavailable) {
                  _configOption.selected = true;
                }
              }

              _this13.makeSelectionConfirmTypeOption(_configOption);
            });
          }
        });
      }
    }
  }, {
    key: "unselectChildProperty",
    value: function unselectChildProperty(_configProperties) {
      var _this14 = this;

      _configProperties === null || _configProperties === void 0 ? void 0 : _configProperties.forEach(function (_configProperty) {
        // inside   _configProperties
        if (_configProperty.options) {
          _configProperty.options.forEach(function (_configOption) {
            // inside _configOptions
            _configOption.selected = false;

            _this14.unselectChildProperty(_configOption.options);
          });
        }
      });
    }
  }, {
    key: "setIsMenuItemLoading",
    value: function () {
      var _setIsMenuItemLoading = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(loading) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._isMenuItemLoading = loading;

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setIsMenuItemLoading(_x) {
        return _setIsMenuItemLoading.apply(this, arguments);
      }

      return setIsMenuItemLoading;
    }()
  }, {
    key: "setIsScrollEnabledFlag",
    value: function () {
      var _setIsScrollEnabledFlag = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(isScrollEnabledFlag) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this._isScrollEnabledFlag = isScrollEnabledFlag;

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setIsScrollEnabledFlag(_x2) {
        return _setIsScrollEnabledFlag.apply(this, arguments);
      }

      return setIsScrollEnabledFlag;
    }()
  }, {
    key: "getTemperatureSelectionTitle",
    value: function getTemperatureSelectionTitle(val, description) {
      var _this$_appAttributes8;

      var shouldShowTempValuesFromAPI = new BrandRules(this === null || this === void 0 ? void 0 : (_this$_appAttributes8 = this._appAttributes) === null || _this$_appAttributes8 === void 0 ? void 0 : _this$_appAttributes8.currentConceptCode).shouldShowTemperatureSelectionDescriptionValuesFromAPI();

      if (shouldShowTempValuesFromAPI && (val || description)) {
        return null;
      }

      return "How do you want your Steak to be cooked";
    }
  }, {
    key: "getTemperatureSelectionPlaceholder",
    value: function getTemperatureSelectionPlaceholder(val) {
      if (val) {
        return val;
      }

      return "Select Steak Temperature";
    }
  }, {
    key: "setIsItemCourseSwitched",
    value: function setIsItemCourseSwitched(val) {
      var _this15 = this;

      runInAction(function () {
        _this15._isItemCourseSwitched = val;
      });
    }
  }, {
    key: "_isOptionDisabled",

    /** Generous-pour disabling duplicate sku's */
    value: function _isOptionDisabled(selectedId, isSelected) {
      var _this$_appAttributes9, _this$_appAttributes10, _this$_appAttributes11;

      var isDisabled = false;

      if ((_this$_appAttributes9 = this._appAttributes) !== null && _this$_appAttributes9 !== void 0 && (_this$_appAttributes10 = _this$_appAttributes9.configs) !== null && _this$_appAttributes10 !== void 0 && (_this$_appAttributes11 = _this$_appAttributes10.generousPourProducts) !== null && _this$_appAttributes11 !== void 0 && _this$_appAttributes11.includes(this.selectedProductId)) {
        var filteredSkuId = this.selectedIds.map(function (_item) {
          return _item.split(":")[1];
        }).includes(selectedId.split(":")[1]);
        isDisabled = filteredSkuId && !isSelected;
      }

      return isDisabled;
    }
  }, {
    key: "configPropertyRefs",
    get: function get() {
      return this._configPropertyRefs;
    }
  }, {
    key: "unavailableItemsList",
    get: function get() {
      return this._unavailableItems;
    }
  }, {
    key: "sessionDetails",
    get: function get() {
      return this._sessionDetails;
    }
  }, {
    key: "editMenuId",
    get: function get() {
      return this._editMenuId;
    }
  }, {
    key: "unavailableProducts",
    get: function get() {
      var _this$_unavailableIte;

      return ((_this$_unavailableIte = this._unavailableItems) === null || _this$_unavailableIte === void 0 ? void 0 : _this$_unavailableIte.productsMap) || {};
    }
  }, {
    key: "unavailableModifiers",
    get: function get() {
      var _this$_unavailableIte2;

      return ((_this$_unavailableIte2 = this._unavailableItems) === null || _this$_unavailableIte2 === void 0 ? void 0 : _this$_unavailableIte2.modifiersMap) || {};
    }
  }, {
    key: "displayGuestNameField",
    get: function get() {
      var _this$_sessionDetails6;

      return !!((_this$_sessionDetails6 = this._sessionDetails) !== null && _this$_sessionDetails6 !== void 0 && _this$_sessionDetails6.displayGuestNameField);
    }
  }, {
    key: "orderType",
    get: function get() {
      var _this$_sessionDetails7, _this$_sessionDetails8;

      return this._orderTypeValue || ((_this$_sessionDetails7 = this._sessionDetails) === null || _this$_sessionDetails7 === void 0 ? void 0 : (_this$_sessionDetails8 = _this$_sessionDetails7.orderContext) === null || _this$_sessionDetails8 === void 0 ? void 0 : _this$_sessionDetails8.orderTypeValue);
    }
  }, {
    key: "menuItem",
    get: function get() {
      if (this._menuItemDetail) {
        var _advacedOrderingInfo$, _this$menulistMap$id;

        var _this$_menuItemDetail = this._menuItemDetail,
            id = _this$_menuItemDetail.id,
            name = _this$_menuItemDetail.name,
            isComplex = _this$_menuItemDetail.isComplex,
            calories = _this$_menuItemDetail.calories,
            imageURL = _this$_menuItemDetail.imageURL,
            price = _this$_menuItemDetail.price,
            description = _this$_menuItemDetail.description,
            longDescription = _this$_menuItemDetail.longDescription,
            indicators = _this$_menuItemDetail.indicators,
            options = _this$_menuItemDetail.options,
            legalDisclaimer = _this$_menuItemDetail.legalDisclaimer,
            displayPrice = _this$_menuItemDetail.displayPrice,
            isDineInOnly = _this$_menuItemDetail.isDineInOnly,
            alcoholSubClassification = _this$_menuItemDetail.alcoholSubClassification,
            winePairingIds = _this$_menuItemDetail.winePairingIds,
            seoMetaDescription = _this$_menuItemDetail.seoMetaDescription,
            dayPartInfo = _this$_menuItemDetail.dayPartInfo,
            advacedOrderingInfo = _this$_menuItemDetail.advacedOrderingInfo;

        var _isAlcohol = options === null || options === void 0 ? void 0 : options.some(function (option) {
          return option === null || option === void 0 ? void 0 : option.isAlcohol;
        });

        var _this$_decodeIsAlcoho = this._decodeIsAlcohol(_isAlcohol, alcoholSubClassification),
            isAlcohol = _this$_decodeIsAlcoho.isAlcohol,
            toolTipMessage = _this$_decodeIsAlcoho.toolTipMessage;

        var _this$checkMenuItemAv = this.checkMenuItemAvailibility(id, dayPartInfo, advacedOrderingInfo),
            isUnavailable = _this$checkMenuItemAv.isUnavailable,
            unAvailableMessage = _this$checkMenuItemAv.unAvailableMessage;

        var isAdvanceOrderingProduct = this._decodeIsAdvanceOrderingProduct(isUnavailable, unAvailableMessage);

        var productAvailableStartDate = advacedOrderingInfo === null || advacedOrderingInfo === void 0 ? void 0 : (_advacedOrderingInfo$ = advacedOrderingInfo[0]) === null || _advacedOrderingInfo$ === void 0 ? void 0 : _advacedOrderingInfo$.startDate;
        return {
          id: id,
          code: id,
          isComplex: isComplex,
          name: name,
          description: description,
          longDescription: longDescription,
          seoMetaDescription: seoMetaDescription,
          calorieCount: calories,
          imageUrl: this.getImageUrl(imageURL),
          isDineInOnly: isDineInOnly,
          isFavourite: false,
          isNew: this.decodeIsNew(indicators),
          isSuggested: false,
          isUnavailable: isAlcohol && this.isTogoDeliveryOrder ? true : isUnavailable,
          unAvailableMessage: unAvailableMessage,
          isAdvanceOrderingProduct: isAdvanceOrderingProduct,
          imgAltText: name,
          slug: "",
          price: this.menuDetailsItemTotalPrice,
          //handle multi price
          indicators: this.decodeIndicators(indicators),
          sodiumIndicator: this.decodeSodiumIndicator(indicators),
          isPriceHidden: this.isPriceHidden,
          displayPrice: this.decodeIfDisplayPrice(price) ? "" : displayPrice,
          isAlcohol: isAlcohol,
          toolTipMessage: toolTipMessage,
          legalDisclaimer: legalDisclaimer,
          breadCrumbSlug: this._selectedItemSlug || ((_this$menulistMap$id = this.menulistMap[id]) === null || _this$menulistMap$id === void 0 ? void 0 : _this$menulistMap$id.breadCrumbSlug) || "",
          productAvailableStartDate: productAvailableStartDate,
          winePairingIds: winePairingIds
        };
      } else {
        return {};
      }
    }
  }, {
    key: "menuDetailsItemTotalPrice",
    get: function get() {
      return this._menuItemDetail ? Number(this._menuItemDetail.itemTotalPrice) * Number(this._quantity) : 0;
    }
  }, {
    key: "isTogoDeliveryOrder",
    get: function get() {
      return this.orderType === ORDER_TYPE.TOGO_DELIVERY;
    }
  }, {
    key: "isPriceHidden",
    get: function get() {
      var _this$_appAttributes12, _this$_appAttributes13, _this$_appAttributes14, _this$_appAttributes15;

      return !this._resturantId && ((_this$_appAttributes12 = this._appAttributes) === null || _this$_appAttributes12 === void 0 ? void 0 : (_this$_appAttributes13 = _this$_appAttributes12.configs) === null || _this$_appAttributes13 === void 0 ? void 0 : _this$_appAttributes13.enableDefaultMenu) === "true" && ((_this$_appAttributes14 = this._appAttributes) === null || _this$_appAttributes14 === void 0 ? void 0 : (_this$_appAttributes15 = _this$_appAttributes14.configs) === null || _this$_appAttributes15 === void 0 ? void 0 : _this$_appAttributes15.hidePricingForDefaultMenu) === "true";
    }
  }, {
    key: "itemInstructionsMaxLength",
    get: function get() {
      var _this$_appAttributes16, _this$_appAttributes17, _this$_appAttributes18, _this$_appAttributes19;

      return (_this$_appAttributes16 = this._appAttributes) !== null && _this$_appAttributes16 !== void 0 && (_this$_appAttributes17 = _this$_appAttributes16.configs) !== null && _this$_appAttributes17 !== void 0 && _this$_appAttributes17.ItemDetailsSplInstrMaxLength ? Number((_this$_appAttributes18 = this._appAttributes) === null || _this$_appAttributes18 === void 0 ? void 0 : (_this$_appAttributes19 = _this$_appAttributes18.configs) === null || _this$_appAttributes19 === void 0 ? void 0 : _this$_appAttributes19.ItemDetailsSplInstrMaxLength) : 50;
    }
  }, {
    key: "specialInstructionsCharacterLength",
    get: function get() {
      var _this$specialInstruct;

      return this.specialInstructions ? (_this$specialInstruct = this.specialInstructions) === null || _this$specialInstruct === void 0 ? void 0 : _this$specialInstruct.length : 0;
    }
  }, {
    key: "itemLevelInstructions",
    get: function get() {
      var _this$_menuItemDetail2, _this$_appAttributes20, _this$_appAttributes21;

      var productLevelEnabled = !!((_this$_menuItemDetail2 = this._menuItemDetail) !== null && _this$_menuItemDetail2 !== void 0 && _this$_menuItemDetail2.displayItemInstruction);
      var siteLevelEnabled = ((_this$_appAttributes20 = this._appAttributes) === null || _this$_appAttributes20 === void 0 ? void 0 : (_this$_appAttributes21 = _this$_appAttributes20.configs) === null || _this$_appAttributes21 === void 0 ? void 0 : _this$_appAttributes21.itemLevelInstructions) === "true";
      var locationLevelEnabled = this.enableItemLevelInstruction;

      if (this.orderType === ORDER_TYPE.ORDER_AHEAD) {
        var _this$_sessionDetails9;

        return siteLevelEnabled && !!((_this$_sessionDetails9 = this._sessionDetails) !== null && _this$_sessionDetails9 !== void 0 && _this$_sessionDetails9.orderAheadItemDescEnabled) && productLevelEnabled && locationLevelEnabled;
      } else {
        return siteLevelEnabled && productLevelEnabled && locationLevelEnabled;
      }
    }
  }, {
    key: "quantity",
    get: function get() {
      return this._quantity;
    },
    set: function set(_quantity) {
      var _this16 = this;

      runInAction(function () {
        _this16._quantity = _quantity;
      });
    }
  }, {
    key: "label",
    get: function get() {
      return this._label;
    },
    set: function set(_label) {
      var _this17 = this;

      runInAction(function () {
        _this17._label = _label;
      });
    }
  }, {
    key: "category",
    get: function get() {
      return this._category;
    }
  }, {
    key: "menuListItems",
    get: function get() {
      return this._menulists ? this._menulists : [];
    }
  }, {
    key: "menulistMap",
    get: function get() {
      return this._menulistMap ? this._menulistMap : {};
    }
  }, {
    key: "specialInstructions",
    get: function get() {
      return this._specialInstructions;
    },
    set: function set(_specialInstructions) {
      var _this18 = this;

      runInAction(function () {
        _this18._specialInstructions = _specialInstructions;
      });
    }
  }, {
    key: "nutritionalInfo",
    get: function get() {
      var _this$_menuItemDetail3, _this$_menuItemDetail4;

      var nutrationalInfoArray = [];
      (_this$_menuItemDetail3 = this._menuItemDetail) === null || _this$_menuItemDetail3 === void 0 ? void 0 : (_this$_menuItemDetail4 = _this$_menuItemDetail3.options) === null || _this$_menuItemDetail4 === void 0 ? void 0 : _this$_menuItemDetail4.forEach(function (sku) {
        var _sku$nutritionalInfo;

        (_sku$nutritionalInfo = sku.nutritionalInfo) === null || _sku$nutritionalInfo === void 0 ? void 0 : _sku$nutritionalInfo.forEach(function (nutrion) {
          nutrationalInfoArray.push(nutrion);
        });
      });
      return nutrationalInfoArray.filter(Boolean);
    }
  }, {
    key: "warnings",
    get: function get() {
      return this._warnings;
    }
  }, {
    key: "recommendations",
    get: function get() {
      var _this$_recommendation,
          _this19 = this,
          _this$_appAttributes22,
          _this$_appAttributes23;

      return this._recommendationsList ? (_this$_recommendation = this._recommendationsList.map(function (_r) {
        return _this19.decodeRecommendations(_r, _this19.menuListItems);
      }).filter(Boolean).filter(function (_i) {
        return !_i.isUnavailable;
      })) === null || _this$_recommendation === void 0 ? void 0 : _this$_recommendation.slice(0, Number((_this$_appAttributes22 = this._appAttributes) === null || _this$_appAttributes22 === void 0 ? void 0 : (_this$_appAttributes23 = _this$_appAttributes22.configs) === null || _this$_appAttributes23 === void 0 ? void 0 : _this$_appAttributes23.productDetailsSmartRecThreshold)) : [];
    }
  }, {
    key: "menuItemSkus",
    get: function get() {
      var _this20 = this;

      if (!this._menuItemDetail) {
        return [];
      }

      return this._menuItemDetail.options.map(function (sku) {
        var _this20$_decodeIsAlco = _this20._decodeIsAlcohol(sku === null || sku === void 0 ? void 0 : sku.isAlcohol, sku === null || sku === void 0 ? void 0 : sku.alcoholSubClassification),
            isAlcohol = _this20$_decodeIsAlco.isAlcohol;

        return {
          id: sku.optionId,
          name: sku.displayName,
          price: sku.price,
          displayPrice: sku.displayPrice,
          isSelected: sku.selected,
          isBeverageItem: _this20._checkSkuIsBeverageItem(sku === null || sku === void 0 ? void 0 : sku.isBeverageItem, isAlcohol),
          isUnavailable: _this20.checkSkuAvailibility(sku.optionId)
        };
      });
    }
  }, {
    key: "disableAddForIsBeverageItem",
    get: function get() {
      var skusWithBeverageItem = this.menuItemSkus.filter(function (sku) {
        return sku.isBeverageItem === true;
      });
      return this.menuItemSkus.length === skusWithBeverageItem.length;
    }
  }, {
    key: "menuItemSku",
    get: function get() {
      if (this._menuItemDetail) {
        var requiredSku = this._menuItemDetail.options.find(function (sku) {
          return sku.selected;
        });

        if (requiredSku) {
          var optionId = requiredSku.optionId,
              description = requiredSku.description,
              price = requiredSku.price,
              options = requiredSku.options,
              displayName = requiredSku.displayName;
          return {
            id: optionId,
            code: optionId,
            description: description,
            price: price,
            properties: this._getProperties(options),
            name: displayName
          };
        }
      }

      return {};
    }
  }, {
    key: "showValidations",
    get: function get() {
      return this._showValidations;
    }
  }, {
    key: "upperSectionHeight",
    get: function get() {
      return this._upperSectionHeight;
    }
  }, {
    key: "selectedMenuItemDetail",
    get: function get() {
      return this._menuItemDetail;
    }
  }, {
    key: "selectedProductId",
    get: function get() {
      var _this$_menuItemDetail5;

      return this === null || this === void 0 ? void 0 : (_this$_menuItemDetail5 = this._menuItemDetail) === null || _this$_menuItemDetail5 === void 0 ? void 0 : _this$_menuItemDetail5.id;
    }
  }, {
    key: "selectedSkuId",
    get: function get() {
      var _this$_menuItemDetail6;

      return (_this$_menuItemDetail6 = this._menuItemDetail.selectedSKU) === null || _this$_menuItemDetail6 === void 0 ? void 0 : _this$_menuItemDetail6.optionId;
    }
  }, {
    key: "selectedIds",
    get: function get() {
      var _this$_menuItemDetail7;

      var allSelectedIds = (_this$_menuItemDetail7 = this._menuItemDetail.selectedSKU) === null || _this$_menuItemDetail7 === void 0 ? void 0 : _this$_menuItemDetail7.selectedIds;
      return allSelectedIds ? allSelectedIds.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.length) > 0;
      }) : []; //Find out why undefined selectedIds are being sent
    }
  }, {
    key: "isValid",
    get: function get() {
      return !this._menuItemDetail.isInValid;
    }
  }, {
    key: "invalidRef",
    get: function get() {
      return null; //TODO: return the ref of the first invalid container so the ui can scroll on Add to cart click
    }
  }, {
    key: "showNutritionalInfo",
    get: function get() {
      return this._showNutritionalInfo;
    }
  }, {
    key: "isFromRecommended",
    get: function get() {
      return this._isFromRecommended;
    }
  }, {
    key: "showTwoColumns",
    get: function get() {
      return new BrandRules(this._appAttributes.concept.conceptCode).showTwoColumns();
    }
  }, {
    key: "showRequiredLabel",
    get: function get() {
      return new BrandRules(this._appAttributes.concept.conceptCode).showRequiredLabel();
    }
  }, {
    key: "showListItemCollapsedByRequired",
    get: function get() {
      return new BrandRules(this._appAttributes.concept.conceptCode).showListItemCollapsedByRequired();
    }
  }, {
    key: "showListItemWithAccordion",
    get: function get() {
      return this._appAttributes.configs.supportBottomSheetForModifiers && this._appAttributes.configs.supportBottomSheetForModifiers === "true";
    }
  }, {
    key: "showCalories",
    get: function get() {
      var _this$_sessionDetails10, _this$_sessionDetails11;

      return (_this$_sessionDetails10 = this._sessionDetails) === null || _this$_sessionDetails10 === void 0 ? void 0 : (_this$_sessionDetails11 = _this$_sessionDetails10.orderContext) === null || _this$_sessionDetails11 === void 0 ? void 0 : _this$_sessionDetails11.showCalories;
    }
  }, {
    key: "showPrice",
    get: function get() {
      var _this$menuItemSku;

      if ((_this$menuItemSku = this.menuItemSku) !== null && _this$menuItemSku !== void 0 && _this$menuItemSku.id) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "isScrollEnabledFlag",
    get: function get() {
      return this._isScrollEnabledFlag;
    }
  }, {
    key: "isMenuItemLoading",
    get: function get() {
      return this._isMenuItemLoading;
    }
  }, {
    key: "hideLegalDisclaimer",
    get: function get() {
      var _this$_appAttributes24;

      return new BrandRules(this === null || this === void 0 ? void 0 : (_this$_appAttributes24 = this._appAttributes) === null || _this$_appAttributes24 === void 0 ? void 0 : _this$_appAttributes24.currentConceptCode).hideLegalDisclaimer();
    }
  }, {
    key: "isDisplayCourseForOrderAhead",
    get: function get() {
      var _this$_menuItemDetail8;

      return ((_this$_menuItemDetail8 = this._menuItemDetail) === null || _this$_menuItemDetail8 === void 0 ? void 0 : _this$_menuItemDetail8.isDisplayCourseForOrderAhead) && this.orderType === 5;
    }
  }, {
    key: "isDIPO",
    get: function get() {
      return this.orderType === ORDER_TYPE.ORDER_AHEAD;
    }
  }, {
    key: "isItemCourseSwitched",
    get: function get() {
      return this._isItemCourseSwitched;
    }
  }, {
    key: "itemCourse",
    get: function get() {
      if (this.orderType === ORDER_TYPE.ORDER_AHEAD) {
        if (this._isItemCourseSwitched) {
          var _this$_menuItemDetail9;

          return (_this$_menuItemDetail9 = this._menuItemDetail) === null || _this$_menuItemDetail9 === void 0 ? void 0 : _this$_menuItemDetail9.alternateCourse;
        } else {
          var _this$_menuItemDetail10, _this$_menuItemDetail11;

          return (_this$_menuItemDetail10 = this._menuItemDetail) !== null && _this$_menuItemDetail10 !== void 0 && _this$_menuItemDetail10.defaultCourse ? (_this$_menuItemDetail11 = this._menuItemDetail) === null || _this$_menuItemDetail11 === void 0 ? void 0 : _this$_menuItemDetail11.defaultCourse : "DEFAULT_COURSE";
        }
      }

      return undefined;
    }
  }, {
    key: "coursingSwitchLabel",
    get: function get() {
      var _this$_menuItemDetail12, _this$_appAttributes25;

      var alternateCourse = (_this$_menuItemDetail12 = this._menuItemDetail) === null || _this$_menuItemDetail12 === void 0 ? void 0 : _this$_menuItemDetail12.alternateCourse;
      var courseOptions = (_this$_appAttributes25 = this._appAttributes) === null || _this$_appAttributes25 === void 0 ? void 0 : _this$_appAttributes25.courseOptions;
      return "Serve with ".concat(courseOptions[alternateCourse]);
    }
  }, {
    key: "selectedItemSlug",
    get: function get() {
      return this._selectedItemSlug;
    },
    set: function set(_val) {
      var _this21 = this;

      runInAction(function () {
        _this21._selectedItemSlug = _val;
      });
    }
  }, {
    key: "enableItemLevelInstruction",
    get: function get() {
      return this._enableItemLevelInstruction;
    },
    set: function set(_val) {
      var _this22 = this;

      runInAction(function () {
        _this22._enableItemLevelInstruction = _val;
      });
    }
  }, {
    key: "hideNutritionalInfoTextOnMenuItemDetails",
    get: function get() {
      var _this$_appAttributes26;

      return new BrandRules(this === null || this === void 0 ? void 0 : (_this$_appAttributes26 = this._appAttributes) === null || _this$_appAttributes26 === void 0 ? void 0 : _this$_appAttributes26.currentConceptCode).hideNutritionalInfoTextOnMenuItemDetails();
    }
  }]);

  return MenuDetailModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_quantity", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 1;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_label", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_specialInstructions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_warnings", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_menuItemDetail", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_showNutritionalInfo", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_category", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_menulists", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_recommendationsList", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_showValidations", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_upperSectionHeight", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 0;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_resturantId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_editMenuId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_orderTypeValue", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_unavailableItems", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_selectedItemSlug", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "_currentPickupTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "_configPropertyRefs", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "_menulistMap", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "_isFromRecommended", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "_isScrollEnabledFlag", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "_isMenuItemLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "_isItemCourseSwitched", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "_enableItemLevelInstruction", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "configPropertyRefs", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "configPropertyRefs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unavailableItemsList", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "unavailableItemsList"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sessionDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "sessionDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "editMenuId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "editMenuId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unavailableProducts", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "unavailableProducts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unavailableModifiers", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "unavailableModifiers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "displayGuestNameField", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "displayGuestNameField"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setOrderTypeValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setOrderTypeValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "menuItem", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "menuItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "menuDetailsItemTotalPrice", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "menuDetailsItemTotalPrice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isTogoDeliveryOrder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isTogoDeliveryOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isPriceHidden", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPriceHidden"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "itemInstructionsMaxLength", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "itemInstructionsMaxLength"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "specialInstructionsCharacterLength", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "specialInstructionsCharacterLength"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "itemLevelInstructions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "itemLevelInstructions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "quantity", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "quantity"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "label", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "label"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "category", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "category"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCategoryData", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setCategoryData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "menuListItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "menuListItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "menulistMap", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "menulistMap"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setMenuListData", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setMenuListData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "specialInstructions", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "specialInstructions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nutritionalInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "nutritionalInfo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "warnings", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "warnings"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "recommendations", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "recommendations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "menuItemSkus", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "menuItemSkus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "disableAddForIsBeverageItem", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "disableAddForIsBeverageItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "menuItemSku", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "menuItemSku"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showValidations", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showValidations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowValidations", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowValidations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "upperSectionHeight", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "upperSectionHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setUpperSectionHeight", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setUpperSectionHeight"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setMenuItemDetailData", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setMenuItemDetailData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setRecommendationData", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setRecommendationData"), _class.prototype), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "selectOptionBySelectedId", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this23 = this;

    return function (selectedId, select) {
      var isEditCartFlow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false; // const menuItemDetailJS = toJS(this._menuItemDetail);

      if (select) {
        var configOption = _this23._menuItemDetail.selectedSKU.findConfigOptionBySelectedId(selectedId);

        configOption.selected = true;
        configOption.propertyDirty = true;

        if (!isEditCartFlow) {
          _this23.makeSelectionConfirmTypeOption(configOption);
        }
      } else {
        var _configOption2 = _this23._menuItemDetail.selectedSKU.findConfigOptionBySelectedId(selectedId);

        _configOption2.selected = false;
        _configOption2.propertyDirty = false;

        _this23.unselectChildProperty(_configOption2.options);
      } // this._menuItemDetail = menuItemDetailJS;

    };
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "selectSKU", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this24 = this;

    return function (optionId) {
      _this24._menuItemDetail.findSKU(optionId).selected = true;
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "selectedProductId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedProductId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedSkuId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedSkuId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedIds", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedIds"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "invalidRef", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "invalidRef"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showNutritionalInfo", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showNutritionalInfo"), _class.prototype), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "setShowNutritionalInfo", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this25 = this;

    return function (show) {
      _this25._showNutritionalInfo = show;
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "isFromRecommended", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFromRecommended"), _class.prototype), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "setIsFromRecommended", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this26 = this;

    return function (isRecommended) {
      _this26._isFromRecommended = isRecommended;
    };
  }
}), _applyDecoratedDescriptor(_class.prototype, "showTwoColumns", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showTwoColumns"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showRequiredLabel", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showRequiredLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showListItemCollapsedByRequired", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showListItemCollapsedByRequired"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showListItemWithAccordion", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showListItemWithAccordion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showCalories", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showCalories"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showPrice", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showPrice"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isScrollEnabledFlag", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isScrollEnabledFlag"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsMenuItemLoading", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsMenuItemLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMenuItemLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMenuItemLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsScrollEnabledFlag", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsScrollEnabledFlag"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideLegalDisclaimer", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideLegalDisclaimer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDisplayCourseForOrderAhead", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDisplayCourseForOrderAhead"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isDIPO", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDIPO"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isItemCourseSwitched", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isItemCourseSwitched"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "itemCourse", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "itemCourse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "coursingSwitchLabel", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "coursingSwitchLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedItemSlug", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedItemSlug"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "enableItemLevelInstruction", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "enableItemLevelInstruction"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideNutritionalInfoTextOnMenuItemDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideNutritionalInfoTextOnMenuItemDetails"), _class.prototype)), _class));
export { MenuDetailModel as default };